import { Button, Div, Text } from "atomize"
import { useContext } from "react"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import Container from "../atoms/Container"
import Divider from "../atoms/Divider"
import PlayerLessonRow from "../player/PlayerLessonRow"
import usePlayerLessons from "../player/usePlayerLessons"
import { modalContext } from "../providers/modal.provider"
import { profileContext } from "../providers/profile.provider"
import { schoolContext } from "../providers/school.provider"
import {
	canEditLesson,
	getLessonsHistoryStartLabel,
	getPlayerFullName,
} from "../utils/func.utils"

// Storico completo delle lezioni di un allievo, caricato a blocchi
export function PlayerLessonsModal({ closeModal, playerData }) {
	const Modal = useContext(modalContext)
	const { coach } = useContext(profileContext)
	const { selectedSchool } = useContext(schoolContext)

	const { lessons, isLoading, isLoadingMore, hasMore, hasError, loadMore } = usePlayerLessons(
		playerData,
		{ pageSize: 20 },
	)

	const handleLessonClick = lessonData =>
		canEditLesson(coach, selectedSchool, lessonData)
			? () => Modal.open("editLesson", lessonData)
			: undefined

	return (
		<>
			<Container>
				<Div
					d="flex"
					justify="space-between"
					align="center"
					m={{ b: "0.5rem" }}
					textWeight="bold"
					textSize="title"
					textColor={theme === "light" ? "text" : "text_alt"}>
					Lezioni di {getPlayerFullName(playerData)}
				</Div>
			</Container>
			<Div maxH="60vh" style={{ overflowY: "auto", overflowX: "hidden" }}>
				<Container>
					{isLoading ? (
						<Text textColor={theme.colors.text_light} p={{ y: "0.5rem" }}>
							Sto cercando le lezioni... 🧐
						</Text>
					) : hasError ? (
						<Text textColor={theme.colors.text_light} p={{ y: "0.5rem" }}>
							Non sono riuscito a leggere le lezioni
						</Text>
					) : lessons.length === 0 ? (
						<Text textColor={theme.colors.text_light} p={{ y: "0.5rem" }}>
							Nessuna lezione da {getLessonsHistoryStartLabel()}
						</Text>
					) : (
						<>
							{lessons.map((lesson, i) => (
								<Div key={lesson.lessonID}>
									<PlayerLessonRow
										lessonData={lesson}
										playerData={playerData}
										onClick={handleLessonClick(lesson)}
										noteBackground={theme.colors.background}
									/>
									{i < lessons.length - 1 && <Divider w="2px solid" />}
								</Div>
							))}
							{!hasMore && (
								<Text
									textSize="caption"
									textAlign="center"
									textColor={theme.colors.text_light}
									p={{ y: "0.75rem" }}>
									Lo storico parte da {getLessonsHistoryStartLabel()}
								</Text>
							)}
							{hasMore && (
								<motion.div whileTap={{ scale: 0.95 }}>
									<Button
										w="100%"
										h="2.75rem"
										m={{ y: "0.75rem" }}
										bg={theme.colors.surface}
										textColor={theme.colors.gunmetal}
										textWeight="bold"
										rounded={theme.rounded["15px"]}
										disabled={isLoadingMore}
										onClick={loadMore}>
										{isLoadingMore ? "Sto caricando..." : "Carica altre lezioni"}
									</Button>
								</motion.div>
							)}
						</>
					)}
				</Container>
			</Div>
			<Container>
				<Div d="flex" justify="center" m={{ t: "1rem" }}>
					<Button
						h="3.5rem"
						p={{ x: "2rem" }}
						bg={theme.colors.gunmetal_fill}
						textColor={theme.colors.white}
						textSize="subheader"
						rounded={theme.rounded["20px"]}
						onClick={closeModal}>
						Chiudi
					</Button>
				</Div>
			</Container>
		</>
	)
}

export default PlayerLessonsModal
